import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import { LanguageRuleInfo } from "../../pages/Messages/schema/languageRule";

import { languageRuleApi } from "./languageRule.api";

interface LanguageRuleState {
	rules: LanguageRuleInfo[];
	defaultOutputLanguage: string | null;
	loaded: boolean;
}

const initialState: LanguageRuleState = {
	rules: [],
	defaultOutputLanguage: null,
	loaded: false,
};

export const languageRuleSlice = createSlice({
	name: "languageRule",
	initialState,
	reducers: {
		resetLanguageRules: (state) => {
			state.rules = [];
			state.defaultOutputLanguage = null;
			state.loaded = false;
		},
	},
	extraReducers: (builder) => {
		builder.addMatcher(
			languageRuleApi.endpoints.getLanguageRules.matchFulfilled,
			(state, { payload }) => {
				if (Array.isArray(payload)) {
					state.rules = payload;
					state.loaded = true;
				}
			}
		);

		builder.addMatcher(
			languageRuleApi.endpoints.createLanguageRule.matchFulfilled,
			(state, { payload }) => {
				state.rules.push(payload);
			}
		);

		builder.addMatcher(
			languageRuleApi.endpoints.updateLanguageRule.matchFulfilled,
			(state, { payload }) => {
				const index = state.rules.findIndex((r) => r.id === payload.id);

				if (index !== -1) {
					state.rules[index] = payload;
				}
			}
		);

		builder.addMatcher(
			languageRuleApi.endpoints.deleteLanguageRule.matchFulfilled,
			(state, { meta }) => {
				const id = meta.arg.originalArgs;

				if (typeof id === "number") {
					state.rules = state.rules.filter((r) => r.id !== id);
				}
			}
		);

		builder.addMatcher(
			languageRuleApi.endpoints.reorderLanguageRules.matchFulfilled,
			(state, { payload }) => {
				if (Array.isArray(payload)) {
					state.rules = payload;
				}
			}
		);

		builder.addMatcher(
			languageRuleApi.endpoints.getDefaultLanguage.matchFulfilled,
			(state, { payload }) => {
				state.defaultOutputLanguage = payload.defaultOutputLanguage;
			}
		);

		builder.addMatcher(
			languageRuleApi.endpoints.setDefaultLanguage.matchFulfilled,
			(state, { payload }) => {
				state.defaultOutputLanguage = payload.defaultOutputLanguage;
			}
		);
	},
});

export const { resetLanguageRules } = languageRuleSlice.actions;
export const languageRuleReducer = languageRuleSlice.reducer;
export const languageRuleSelector = (state: RootState) => state[languageRuleSlice.name];
